import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import Pagetitle from "../Components/Pagetitle";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { getData } from "../Api";

function Blog() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await getData("/blogs"); 
        setBlogs(response.data || []);
      } catch (error) {
        console.error("Error fetching blogs:", error);
        setBlogs([]); 
      }
    };

    fetchBlogs();
  }, []);

  return (
    <>
      <main className="container-fluid">
        <Header />
        <Pagetitle />

        <div className="py-5 px-sm-5">
          <div className="row g-4">
            {blogs.map((blog, index) => (
              <div className="col-xl-3 col-md-4 col-sm-6" key={index}>
                <Link to={`/blogs/${blog.slug}`} className="linktext">
                  <div className="card shadow-sm cardblog">
                    <div className="position-relative">
                      <img
                        src={`${blog.image}`}
                        className="card-img-top"
                        alt={blog.title}
                      />
                      <span className="badge bg-success position-absolute top-0 end-0 m-2">
                        HEALTH CARE
                      </span>
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">{blog.title}</h5>
                     
                      <Link to={`/blogs/${blog.slug}`} className="text-success fw-bold">
                        READ MORE »
                      </Link>
                    </div>
                    <div className="card-footer text-muted">
                      {new Date(blog.created_at).toDateString()} {/* Format Date */}
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>

        <Footer />
      </main>
    </>
  );
}

export default Blog;
